import { CountryData } from '@models/Country'
import { dataVersions } from '@utils/data'

export const V2025 = '2025'
// dataVersions cannot be empty, data.ts throws at module init if every registry
// entry has expired. That invariant is deliberate, an all-expired registry is a
// deploy mistake that must fail loudly, not degrade to stale amounts.
export const DEFAULT_VERSION: VersionYear = dataVersions[0].year
export type VersionYear = '2025'

export const VersionStorage = 'v20260901'

export interface Version {
  year: VersionYear
  label: string
  file: string
  documentId: string
  validFrom: string
  validUntil: string
  countries: CountryData[]
}
